import { Link } from 'react-router-dom';

const ContactCTA = () => (
  <section className="section-pad bg-white overflow-hidden">
    <div className="max-w-7xl mx-auto px-4">
      <div className="grid md:grid-cols-2 gap-6">
        <div className="relative overflow-hidden bg-[#0f2347] p-6 sm:p-10 flex flex-col justify-between min-h-[260px]">
          <div className="absolute right-0 top-0 w-32 h-32 sm:w-48 sm:h-48 bg-[#e63946]/10 rounded-full translate-x-1/2 -translate-y-1/2 pointer-events-none"/>
          <div className="relative">
            <span className="inline-block text-[#e63946] text-xs font-black uppercase tracking-widest mb-3">Corporate & Bulk</span>
            <h3 className="font-display text-2xl sm:text-3xl font-black text-white mb-2">Need Bulk Orders?</h3>
            <p className="text-white/60 text-sm leading-relaxed mb-5">Special pricing for 10+ pieces. Hotels, offices, restaurants. Get a custom quote today.</p>
          </div>
          <Link to="/contact" className="inline-flex items-center gap-2 bg-[#e63946] text-white px-5 py-3 font-bold text-sm hover:bg-white hover:text-[#e63946] transition-all duration-300 self-start relative z-10">
            Get Bulk Quote
            <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"/></svg>
          </Link>
        </div>
        <div className="bg-[#f8f9fc] p-6 sm:p-10 flex flex-col justify-between min-h-[260px]">
          <div>
            <span className="inline-block text-[#e63946] text-xs font-black uppercase tracking-widest mb-3">Get In Touch</span>
            <h3 className="font-display text-2xl sm:text-3xl font-black text-gray-900 mb-2">Have Questions?</h3>
            <p className="text-gray-500 text-sm leading-relaxed mb-5">Our team is ready to help. Contact us via WhatsApp, call, or email.</p>
          </div>
          <div className="space-y-3">
            <a href="tel:+923331420200" className="flex items-center gap-3 text-sm font-semibold text-gray-700 hover:text-[#1a3a6e] transition-colors group">
              <div className="w-10 h-10 bg-[#1a3a6e] flex items-center justify-center flex-shrink-0 group-hover:bg-[#e63946] transition-colors rounded-sm">
                <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/></svg>
              </div>
              +92 333 1420200
            </a>
            <a href="mailto:info@sitsmart.store" className="flex items-center gap-3 text-sm font-semibold text-gray-700 hover:text-[#1a3a6e] transition-colors group">
              <div className="w-10 h-10 bg-[#1a3a6e] flex items-center justify-center flex-shrink-0 group-hover:bg-[#e63946] transition-colors rounded-sm">
                <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
              </div>
              info@sitsmart.store
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ContactCTA;
